import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';
import { UserService } from '../shared/service/user-service';
import { AppConstants } from '../constants/app-constants';
import { MatDialog } from '@angular/material/dialog';
import { LocalStorageUtil } from '../shared/utils/local-storage/local-storage-util';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private router: Router, private userService: UserService, public dialog: MatDialog, private localStorageUtil: LocalStorageUtil) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        //1. Check If loggedIn 
        //2. Check If Candidate Login 
        //3. If authentication Fails - logout
        //4. If success - navigate 
        if (request.url.includes('cp/secure')) { //|| request.url.includes('cp/onboard') || request.url.includes('cp/common')
            if (this.localStorageUtil.isAccessTokenPresentAndValid()) {
                let accesstoken = this.localStorageUtil.getAccessToken();
                // Secure Link needs access Token
                request = request.clone({
                    setHeaders: {
                        'Content-Language': 'en-US',
                        // Authorization: `Bearer ${accesstoken}`,
                        Authorization: `Bearer ${accesstoken.jwt}`,
                        UserAgent: window.navigator.userAgent,
                    }
                });
            }
            // When No "Access_Token" is present in the session/cookie/localstorage
            else {
                this.localStorageUtil.handleSessionInvalidError();
            }
        }
        //Handle Authentication Error
        return next.handle(request)
            .pipe(
                tap(evt => { }),
                catchError((error: HttpErrorResponse) => {
                    let errorMessage = '';
                    if (error.error instanceof ErrorEvent) {
                        // client-side error
                        errorMessage = `Error: ${error.error.message}`;
                    } else {
                        // server-side error
                        errorMessage = `Error Code: ${error.status}`;
                    }
                    if (error.status == 403 || error.status == 511 || error.status == 0) {
                        // If request is applicant submit -- Cache the Request
                        // Show a popup to login and data not discarded message
                        // Else -- Show a popup to login or continue without login 
                        // DONOT REMOVE COMMENTS 
                        // if (request.url === AppConstants.SERVER_URL + AppConstants.BASE_URL + AppConstants.SECURE_URL + "candidate/" ||
                        //     request.url === AppConstants.SERVER_URL + AppConstants.BASE_URL + AppConstants.SECURE_URL + "onboard/updatecandidateindb" ||
                        //     request.url === AppConstants.SERVER_URL + AppConstants.BASE_URL + AppConstants.SECURE_URL + 'common/updatecompcandidatefiles' ||
                        //     request.url === AppConstants.SERVER_URL + AppConstants.BASE_URL + AppConstants.SECURE_URL + 'common/updateeduexpcandidatefiles' ||
                        //     request.url === AppConstants.SERVER_URL + AppConstants.BASE_URL + AppConstants.SECURE_URL + 'common/updateidattachcandidatefiles' ||
                        //     request.url === AppConstants.SERVER_URL + AppConstants.BASE_URL + AppConstants.SECURE_URL + 'common/updateformscandidatefiles') {
                        if (request.url === AppConstants.SERVER_URL + AppConstants.BASE_URL + AppConstants.SECURE_URL + "candidate/" ||
                            request.url === AppConstants.SERVER_URL + AppConstants.BASE_URL + AppConstants.SECURE_URL + "onboard/updatecandidateindb") {
                            let bodyString: string | undefined;
                            if (request.body instanceof FormData) {
                                // Convert FormData to plain object for logging
                                const formDataObject = {};
                                request.body.forEach((value, key) => {
                                    formDataObject[key] = value;
                                });
                                bodyString = JSON.stringify(formDataObject);
                            } else {
                                bodyString = JSON.stringify(request.body);
                            }
                            // CACHING DATA
                            // Files Cannot be cached. Hence Resume will not be cached and user will have to upload fresh. Only data will be cached
                            sessionStorage.setItem("cachedRequests", JSON.stringify(request));
                            sessionStorage.setItem("requestBody", bodyString)
                            sessionStorage.setItem("redirectLink", this.router.url);
                            // Clearing Only Local Storage. Session Persists
                            this.userService.setClearLocalStorage('clear');
                            this.localStorageUtil.clearLocalStorage();
                            // Opening Session Expired Dialog
                            let data = { url: request.url };
                            this.localStorageUtil.triggerSessionExpiredDialog(data);
                        }
                        else {
                            // Clearing both LocalStorage & Session Storage 
                            this.userService.setClearLocalStorage('clear'); // Used in Header Component
                            this.localStorageUtil.clearLocalStorage();
                            this.localStorageUtil.clearSessionStorageExceptExclusionKey();
                            // Opening Session Expired Dialog
                            let data = { url: request.url };
                            this.localStorageUtil.triggerSessionExpiredDialog(data);
                        }
                    }
                    return throwError(error);
                })
            )
    }
}
